import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { ChapterDetail } from '@shared/types';

export function useChapter(chapterId: string | undefined, mode: 'draft' | 'published' = 'published') {
  return useQuery({
    queryKey: ['chapters', chapterId, mode],
    queryFn: () => api.get<{ chapter: ChapterDetail }>(`/chapters/${chapterId}?mode=${mode}`),
    enabled: !!chapterId,
  });
}

export function useUpdateChapterDraft(chapterId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: Partial<{
      title_cs: string;
      content_cs_md: string;
      requires_acknowledgment: boolean;
    }>) => api.patch<{ ok: true }>(`/chapters/${chapterId}`, patch),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['chapters', chapterId] });
      qc.invalidateQueries({ queryKey: ['sections'] });
    },
  });
}
